<template>
    <div>
        <audio ref="audioPlayer" controls style="width: 100%;"></audio>
    </div>
</template>

<script>
import Hls from 'hls.js';

export default {
    name: 'AudioPlayer',
    props: {
        src: {
            type: String,
            required: true,
        },
    },
    mounted() {
        const audio = this.$refs.audioPlayer;
        const isHls = this.src && this.src.toLowerCase().includes('.m3u8');

        if (isHls && Hls.isSupported()) {
            const hls = new Hls();
            hls.loadSource(this.src);
            hls.attachMedia(audio);
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                audio.play();
            });
            this._hls = hls;
            return;
        }

        if (isHls && audio.canPlayType('application/vnd.apple.mpegurl')) {
            // Native HLS (Safari)
            audio.src = this.src;
            audio.addEventListener('loadedmetadata', () => audio.play(), { once: true });
            return;
        }

        // Non-HLS sources (e.g., AAC/MP3/Blob)
        audio.src = this.src;
        audio.load();
        audio.addEventListener('loadedmetadata', () => {
            // Do not autoplay; keep pause state unless you want to auto-play
        }, { once: true });
    },
    beforeUnmount() {
        if (this._hls) {
            this._hls.destroy();
            this._hls = null;
        }
    }
};
</script>

<style scoped>
audio {
    display: block;
    margin-right: 50%;
}
</style>